import config from '@/assets/config'
import { getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s8ScrollD = config.scenesScrollD[7]
const s8ScrollT = config.scenesScrollT[7]

const s7ScrollD = config.scenesScrollD[6]
const s7ScrollT = config.scenesScrollT[6]
const s7Static2MoveD = s7ScrollD + 0.65 * s7ScrollT
const s7Text1D = s7Static2MoveD + s7ScrollT * 0.03
const s7TextT = s7ScrollT * 0.02
const s7Text2D = s7Text1D + s7TextT * 4
const s7Text3D = s7Text2D + s7TextT * 4
const s7EndFadeD = s7Text3D
const s7EndFadeT = s7TextT * 8

// 转身
const s8MeD = s8ScrollD
const s8MeT = s8ScrollT * 0.1

// 文字1
const s8TextD = s8ScrollD
const s8TextT = s8ScrollT * 0.05

// 走路抬头
const s8WalkD = s8MeD + s8MeT
const s8WalkT = s8ScrollT * 0.1

// 气泡
const s8TalkD = s8WalkD + s8WalkT // 0.2T
const s8TalkT = s8ScrollT * 0.04
const s8TalkH = wh * 457 / 2436
const s8TalkW = s8TalkH * 187 / 457

// 镜头上移
const s8MoveD = s8ScrollD + s8ScrollT * 0.4 // 0.4T
const s8MoveT = s8ScrollT * 0.1
const s8Static2H = ww / (1125 / 2491)

// 星星浮现
const s8StarD = s8MoveD + s8MoveT / 2 // 0.45T
const s8StarT = s8ScrollT * 0.05

// 文字1
const s8Text2D = s8StarD + s8StarT / 2 // 0.5T
const s8Text2T = s8ScrollT * 0.05

// 鸟
const s8BirdD = s8ScrollD + s8ScrollT * 0.6 // 0.6T
const s8BirdT = s8ScrollT * 0.012
const s8BirdDs = []
for (let i = 0; i <= 9; i += 1) {
  s8BirdDs.push(s8BirdD + s8BirdT * i * 2)
}

// 文字和星星淡出
const s8TextFadeD = s8BirdD
const s8TextFadeT = s8ScrollT * 0.2

// 背景淡出
const s8BgFadeD = s8BirdD
const s8BgFadeT = s8ScrollT * 0.3

// 家书滑入
const margin = 10 * (wh / 603) * (wh / 603) * (wh / 603) * (wh / 603)
const s8EndH = ww / (1125 / 912)
const s8Text3H = ww * (809 * (wh / 603) / 1125) / (809 / 486)
const s8BtnW = ww * (398 * (wh / 603) / 1125)
const s8BtnH = s8BtnW / (398 / 122)
const s8LogoH = ww * (278 / 1125) / (278 / 71)
const totalH = s8EndH + s8Text3H + s8BtnH + s8LogoH + margin * 3
const s8EndTop = (wh - totalH) / 2
const s8Text3Top = s8EndTop + s8EndH + margin
const s8BtnTop = s8Text3Top + s8Text3H + margin
const s8LogoTop = s8BtnTop + s8BtnH + margin

const s8EndD = s8ScrollD + s8ScrollT * 0.85 // 0.9T
const s8EndT = s8ScrollT * 0.15

const animations = {
  s8_static: [
    {
      delay: s8MeD,
      duration: s8MeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7EndFadeD,
      duration: s7EndFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s8_text: [
    {
      delay: s8TextD,
      duration: s8TextT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s8TextT * 6 }
    }
  ],
  s8_me: [
    {
      delay: s8WalkD,
      duration: s8ScrollT * 0.01,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7EndFadeD,
      duration: s7EndFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s8MeD,
      duration: s8MeT,
      frames: getFrames('s8_me', 4, 1)
    }
  ],
  s8_bg: [
    {
      delay: s8BgFadeD,
      duration: s8BgFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s8MeD,
      duration: s8MeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s8_static2: [
    {
      delay: s8MeD,
      duration: s8MeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s8MoveD,
      duration: s8MoveT,
      from: { y: wh },
      to: { y: wh + s8Static2H, ease: 'ease' }
    }
  ],
  s8_walk: [
    {
      delay: s8WalkD,
      duration: s8ScrollT * 0.01,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s8WalkD,
      duration: s8WalkT,
      frames: getFrames('s8_walk', 5, 1)
    },
    {
      delay: s8MoveD,
      duration: s8MoveT,
      from: { y: 1550 / 2436 * wh },
      to: { y: 1550 / 2436 * wh + s8Static2H, ease: 'ease' }
    }
  ],
  s8_talk: [
    {
      delay: s8TalkD,
      duration: s8TalkT,
      from: { width: 0, height: 0, alpha: 0 },
      to: { width: s8TalkW, height: s8TalkH, alpha: 1, yoyo: true, repeat: 1, repeatDelay: s8TalkT * 3 }
    }
  ],
  s8_star: [
    {
      delay: s8BgFadeD,
      duration: s8BgFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s8StarD,
      duration: s8StarT,
      from: { alpha: 0, y: wh * 0.4 },
      to: { alpha: 1, y: wh * 0.5, ease: 'ease' }
    }
  ],
  s8_text2: [
    {
      delay: s8TextFadeD,
      duration: s8TextFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s8Text2D,
      duration: s8Text2T,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s8_js: [
    {
      delay: s8EndD,
      duration: s8EndT,
      from: { y: s8EndTop + wh },
      to: { y: s8EndTop, ease: 'ease' }
    }
  ],
  s8_text3: [
    {
      delay: s8EndD,
      duration: s8EndT,
      from: { y: s8Text3Top + wh },
      to: { y: s8Text3Top, ease: 'ease' }
    }
  ],
  s8_btnagain: [
    {
      duration: 1,
      from: { width: s8BtnW, height: s8BtnH },
      to: { width: s8BtnW * 0.95, height: s8BtnH * 0.95, yoyo: true, repeat: -1, ease: 'ease' }
    },
    {
      delay: s8EndD,
      duration: s8EndT,
      from: { y: s8BtnTop + wh },
      to: { y: s8BtnTop, ease: 'ease' }
    }
  ],
  s8_btnshare: [
    {
      duration: 1,
      from: { width: s8BtnW, height: s8BtnH },
      to: { width: s8BtnW * 0.98, height: s8BtnH * 0.98, yoyo: true, repeat: -1, ease: 'ease' }
    },
    {
      delay: s8EndD,
      duration: s8EndT,
      from: { y: s8BtnTop + wh },
      to: { y: s8BtnTop, ease: 'ease' }
    }
  ],
  s8_logo: [
    {
      delay: s8EndD,
      duration: s8EndT,
      from: { y: s8LogoTop + wh },
      to: { y: s8LogoTop, ease: 'ease' }
    }
  ]
}

s8BirdDs.forEach((d, index) => {
  animations[`s8_bird${index + 1}`] = [
    {
      delay: d,
      duration: s8BirdT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s8BirdT }
    }
  ]
})

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s8/spritesAnimations.js